import GPIConditionalLogicFormAdmin from './GPIConditionalLogicFormAdmin';

window.GPIConditionalLogicFormAdminInstance =
	new GPIConditionalLogicFormAdmin();
